import { ApiClientAxios, apiFactoryConfig, SetContributionRequest } from "@repo/api";
import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";

type ChangeContributionVariables = { contractId: string; data: SetContributionRequest };

export const useChangeContributionMutation = (
    options?: Partial<UseMutationOptions<void, Error, ChangeContributionVariables>>,
) => {
    const queryClient = useQueryClient();

    const api = ApiClientAxios.ContractsDpsApiFactory(...apiFactoryConfig);

    return useMutation<void, Error, ChangeContributionVariables>({
        mutationFn: async ({ contractId, data }: ChangeContributionVariables) => {
            await api.setDPSContributionPut(contractId, data); //New endpoint for dps funds change
        },
        onSuccess: async () => {
            // Invalidate any queries or perform any side effects here if needed
            await queryClient.invalidateQueries({ queryKey: ["allowedChanges"] });
            await queryClient.invalidateQueries({ queryKey: ["dpsAllowedChanges"] });
        },
        ...options,
    });
};
